import React, { useState } from 'react'
import useUser from '../../hooks/useUser'
import { Filter, TextInput, List, Datagrid, TextField, ShowButton, EditButton, ReferenceInput, SelectInput } from 'react-admin';
import ListPagination from '../../components/ListPagination'
import ConfirmDeleteButton from '../../components/ConfirmDeleteButton'
import ConfirmBulkActions from '../../components/ConfirmBulkActions'
import { perPage } from '../../defaults/Defaults'

const ContactListFilter = (props) => {

    const user = useUser()
    return (
        <Filter {...props}>
            <TextInput label="Search by name" source="name" alwaysOn />
            {user.role === 'super-admin' && <ReferenceInput perPage={1000000000000} label="Choose Organization" source="OrganizationId" reference="organizations">
                <SelectInput optionText="name" />
            </ReferenceInput>}
        </Filter>
    );
}

const ContactListList = (props) => {

    let [gridKey, changeGridKey] = useState(Math.random())

    const updateDataGrid = () => changeGridKey(Math.random())
    const alertM = `Warning, this cannot be undone. This contact list will be deleted permanently.`

    return (
        <List key={gridKey} {...props} bulkActionButtons={<ConfirmBulkActions />} perPage={perPage} pagination={<ListPagination />} title="Contact Lists" filters={<ContactListFilter />}>
            <Datagrid>
                <TextField source="name" />
                <ShowButton />
                <EditButton />
                <ConfirmDeleteButton
                    dataprovidersource={`contactlists`}
                    alertmessage={alertM}
                    update={updateDataGrid} />
            </Datagrid >
        </List >
    )
}

export default ContactListList;